var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    staticClass: "primary",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("预览")])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "logo"
  }, [_vm._v("Resumer")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-796ea49d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = mZOR
// module chunks = 1